import {
	CalendarDays,
	MapPin,
	Hash,
	CheckSquare,
	FileText,
	List,
	Type,
	ToggleLeft,
	User,
	Mail,
	Phone,
	Clock,
	AlertCircle,
	Sparkles,
	CheckCircle,
	MessageSquare,
	MessageSquareText,
	Percent,
	Calendar,
	MessageCircle,
	Scale,
	type LucideIcon
} from 'lucide-react';

// Resolves string icon names from database schema to actual Lucide components
export const ICON_MAP: Record<string, LucideIcon> = {
	CalendarDays,
	MapPin,
	Hash,
	CheckSquare,
	FileText,
	List,
	Type,
	ToggleLeft,
	User,
	Mail,
	Phone,
	Clock,
	AlertCircle,
	Sparkles,
	CheckCircle,
	MessageSquare,
	MessageSquareText,
	Percent,
	Calendar,
	MessageCircle,
	Scale
};

export function resolveIcon(iconName?: string): LucideIcon {
	if (!iconName) return FileText;
	return ICON_MAP[iconName] || FileText;
}
